const crosswordsArticles = [
  {
    title: "Big game blues",
    author: "Nicholas Fink, Manuela Moreyra, Ananya Govindarajan",
    articleLink: "https://www.columbiaspectator.com/multimedia/2025/10/14/big-game-blues/",
    image: "https://www.columbiaspectator.com/resizer/v2/2MDWS73TIRDJROK4M2MGZ7UKAE.png?auth=60168836f84101dfef1dc0c5285720419182d4e5420adcc1595abfac4f62b1c0"
  }
];
export default crosswordsArticles;